import { AttorneysList } from 'components/sidenav-message/attorneys/AttorneysList';

import { AttorneyInfo } from 'components/card/attorney/attorney-info/AttorneyInfo';
import { Loader } from 'components/loader/loader';
import { NotFound, NotFoundContainer } from 'components/not-found';
import { AppRoutes } from 'config/routes';
import { useNavigateWithCurrentParams } from 'hooks';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetPoaActiveListQuery } from 'store/api/poa';
import { PoaDraft } from 'store/api/types';
import s from './Active.module.scss';

export const Active = () => {
  const { id } = useParams();
  const navigate = useNavigateWithCurrentParams();
  const urlParams = new URLSearchParams(location.search);
  const representativeEmployeeID = urlParams.get('representativeEmployeeID');

  const { data = [], isFetching } = useGetPoaActiveListQuery({ representativeEmployeeID });
  const [currentItem, setCurrentItem] = useState<PoaDraft | null>(null);

  const { Home, PowersAttorney } = AppRoutes.Dashboard;

  useEffect(() => {
    if (!id && data?.length) {
      navigate(Home + PowersAttorney.Home + PowersAttorney.Active + '/' + data[0]?.id);
    }
    setCurrentItem(data?.find((item) => item.id === id) ?? data?.[0]);
  }, [id, data]);

  if (!isFetching && !data?.length) {
    return (
      <NotFoundContainer>
        <NotFound
          hasSearch={false}
          title="Here will be displayed"
          subtitle="your powers of attorney"
          notFoundTitle="No power of attorney found"
        />
      </NotFoundContainer>
    );
  }

  if (isFetching) {
    return <Loader size="medium" />;
  }

  return (
    <div className={s['container']}>
      <AttorneysList data={data} current={currentItem?.id ?? null} hasSearch />
      <AttorneyInfo currentItem={currentItem} />
    </div>
  );
};
